<template>
  <div>
    <component
      :is="metadataComponent"
      :metadata="metadata"
      :alert-type="alertType"
    />
  </div>
</template>

<script>
import GenericMetadata from '@/xvisor/components/xtend/tabs/XtendAlertsGenericMetadata.vue';
import SentenceMetadata from '@/xvisor/components/xtend/tabs/XtendAlertsSentencesMetaData.vue';

export default {
  props: {
    metadata: {
      type: Object,
      required: true,
    },
    alertType: {
      type: String,
      required: true,
    },
  },
  computed: {
    metadataComponent() {
      if (this.alertType === 'AI/ML') {
        return SentenceMetadata;
      }
      return GenericMetadata;
    },
  },
};
</script>
